/**
 * Creates a promise that resolves after the given number of milliseconds
 * @param {number} ms - number of ms before returning the resolved promise
 * @returns {Promise}
 */
export async function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
